<template>
  <section
    class="min-w-0 rounded-theme-md border bg-theme-surface border-theme-border p-4 shadow-cockpit-card
      dark:bg-theme-surface dark:border-theme-border"
  >
    <header class="flex min-w-0 items-center justify-between gap-3 mb-3">
      <div class="min-w-0 flex-1">
        <h2 class="text-base font-semibold text-theme-text">
          {{ t('home_cockpit.snapshot.title') }}
        </h2>
        <p class="text-xs text-theme-text-secondary">
          {{ demo ? t('portal_demo.workspace_body') : t('home_cockpit.snapshot.subtitle') }}
        </p>
      </div>
      <router-link
:to="demo ? '/subscriptions?intent=platform' : '/my-environment/overview'"
        class="inline-flex shrink-0 items-center gap-1 text-sm font-medium text-theme-brand hover:text-theme-brand-hover"
      >
        <span>{{ demo ? t('portal_demo.plans') : t('home_cockpit.snapshot.go_to') }}</span>
        <icon :path="mdiArrowRight" size="14" />
      </router-link>
    </header>

    <!--
      Compact 4-column strip. Each section renders its `snapshot` variant
      (tight padding, one-line items). Dashboards are intentionally omitted
      from this row.
    -->
    <!--
      Each snapshot card gets its own home-snapshot-{section} hook on a wrapper
      (the section itself already owns its my-env-section-{...} hook, so the two
      hooks can't share one element). `grid` on the wrapper stretches the single
      child section to the equal row height — without passing a fall-through
      class to the section, which fragment-rooted sections can't inherit.
    -->
    <div v-if="demo" class="grid min-w-0 grid-cols-2 md:grid-cols-4 gap-3" data-test="demo-workspace-locked">
      <div v-for="section in ['kpis', 'charts', 'alerts', 'toolruns']" :key="section" class="rounded-theme-md border border-theme-border p-3">
        <icon :path="mdiLockOutline" class="mb-2 text-theme-brand" :size="18" />
        <h3 class="text-sm font-semibold text-theme-text">{{ t(`portal_demo.snapshot_${section}`) }}</h3>
        <p class="mt-1 text-xs text-theme-text-secondary">{{ t('portal_demo.locked_title') }}</p>
      </div>
    </div>
    <div v-else class="grid min-w-0 grid-cols-2 md:grid-cols-4 gap-3">
      <div data-test="home-snapshot-kpis" class="grid min-w-0">
        <my-kpis-section :limit="3" snapshot />
      </div>
      <div data-test="home-snapshot-charts" class="grid min-w-0">
        <my-charts-section :limit="2" snapshot />
      </div>
      <div data-test="home-snapshot-alerts" class="grid min-w-0">
        <my-alerts-section :limit="2" snapshot />
      </div>
      <div data-test="home-snapshot-toolruns" class="grid min-w-0">
        <my-toolruns-section :limit="2" snapshot />
      </div>
    </div>

  </section>
</template>

<script setup>
  /* eslint-disable no-undef */
  import Icon from '@/components/Icon';
  import MyAlertsSection from '@/pages/my-environment/components/MyAlertsSection.vue';
  import MyChartsSection from '@/pages/my-environment/components/MyChartsSection.vue';
  import MyKpisSection from '@/pages/my-environment/components/MyKpisSection.vue';
  import MyToolrunsSection from '@/pages/my-environment/components/MyToolrunsSection.vue';
  import { mdiArrowRight, mdiLockOutline } from '@mdi/js';
  import { useI18n } from 'vue-i18n';

  defineProps({ demo: Boolean });
  const { t } = useI18n();
</script>
